import { Box } from "@mui/material";
import { ReactElement } from "react";

import { HandlerType } from "models/Date";

import { Date } from "./Date";

export function Info(): ReactElement {
    return (
        <Box sx={{ display: "flex", height: 100 }}>
            <Date
                key={HandlerType.DATE}
                handlerType={HandlerType.DATE}
            />
            <Date
                key={HandlerType.HOUR}
                handlerType={HandlerType.HOUR}
            />
        </Box>
    );
}